<template>
  <div v-if="hasRole(roles.ACC_FIN_TRAVELREFUND_SEARCH_BOARD_APPROVAL)">
    <div class="d-flex" v-if="!editOn && !detailsTerm">
        <div class="col-md-3">
          <div class="salestotal" v-if="tabIndex === 0">
          <div class="d-flex justify-content-center pt-3 title-card-sales">Total de Termos </div>
          <div class="sales-value">{{formatMoney(totalTerm.valorTotal)}}</div>
          <hr>
          <div class="sales-value-body" v-for="data in totalTerm.lote" :key="data.lote">{{data.lote + ' Lote - ' + formatMoney(data.valor)}}</div>
          </div>
           <div class="salestotal" v-if="tabIndex === 1">
          <div class="d-flex justify-content-center pt-3 title-card-sales">Total de Desconto em Folha</div>
          <div class="sales-value">{{formatMoney(totalDesconto.valorTotal)}}</div>
          <hr>
          <div class="sales-value-body" v-for="data in totalDesconto.lote" :key="data.lote">{{data.lote + ' Lote - ' +  formatMoney(data.valor)}}</div>
          </div>
          <div class="salestotal" v-if="tabIndex === 2">
          <div class="d-flex justify-content-center pt-3 title-card-sales">Total de Reembolso </div>
          <div class="sales-value">{{formatMoney(totalReembolso.valorTotal)}}</div>
          <hr>
          <div class="sales-value-body" v-for="data in totalReembolso.lote" :key="data.lote">{{data.lote + ' Lote - '  + formatMoney(data.valor)}}</div>
          </div>
          <div class="salestotal" v-if="tabIndex === 3">
            <!-- <Search :calcularTotalDespesaViagemUsuario="calcularTotalDespesaViagemUsuario" @onLoadFuncionario="getDespesasViagemDiretoria"/> -->
            <div class="d-flex justify-content-center pt-3 title-card-sales">Total de Despesas</div>
            <div class="sales-value">{{ formatMoney(despesaViagemValorTotal) }}</div>
            <hr>
          </div>
          <div class="salestotal" v-if="tabIndex === 4">
            <!-- <Search :calcularTotalDespesaViagemUsuario="calcularTotalDespesaViagemUsuario" @onLoadFuncionario="getDespesasViagemDiretoria"/> -->
            <div class="d-flex justify-content-center pt-3 title-card-sales">Total de Despesas</div>
            <div class="sales-value">{{formatMoney(despesaDiversosValorTotal)}}</div>
            <hr>
          </div>
            <div class="mt-3"  v-if="tabIndex === 3 || tabIndex === 4">
            <ExpenseSearch  @search="Lote = $event.Lote ;funcionarioId = $event.FuncionarioId ;shouldSearch = !shouldSearch"/>
            </div>
          <div class="mt-3">
          <Formserachauthorization :detailsDire="true"  v-if="tabIndex == 0" v-on:searchAuth="searchAuth"></Formserachauthorization>
          <Newformserarch  :tabIndex="tabIndex == 1 ? true : false" :detailsDire="true" v-on:search="search" v-if="tabIndex != 0 && tabIndex != 3 && tabIndex != 4"></Newformserarch>
          </div>
          <div>
          </div>
        </div>
      <div class="col-md-9">
        <b-tabs v-model="tabIndex">
           <b-tab :title="'Autorizações'">
            <template slot="title">
              <i class="fas fa-file-contract text-third"></i><span class="d-md-down-none pl-1 text-third"> Adiantamento</span>
            </template>
         <Tables ref="tableGridTerm"
        :columns="[
                  'Lote',
                  'Data Solicitação',
                  'Solicitante',
                  'Funcionário',
                  'Função',
                  'Obra',
                  'Responsável',
                  'Regional',
                  'Valor',
                  'Viagem Motivo',
                  'Viagem Início',
                  'Viagem Fim',
                  'Cidade Origem',
                  'Cidade Destino',
                  'Situação',
                  'Situação Data',
                  'Situação Aprovador',
                  'Situação Motivo',
                  'Ações',
                ]"
        :showReload="false"
        v-on:Load="onloadFirst"
        :showButtonNew="true"
        :newHeaderStatus="true"
        :showCheckInput="true"
        v-on:check="checkedTerm"
        >
      <tr v-for="(obj, index) in dataTerm" v-bind:key="index">
        <TableColumn  :IsCustom="true" class="pl-3">
          <b-form-checkbox :id="`accept-${index}`" :name="`accept-${index}`" v-model="obj.checked" :value="obj.id" unchecked-value="" size="sm"></b-form-checkbox>
        </TableColumn>
        <TableColumn  :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.termoAnexoLog ? obj.termoAnexoLog.lote  + ' Lote'  : ''" />
        <TableColumn   :IsDatetime="true" v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.dataSolicitacao" />
        <TableColumn  :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.solicitante ? obj.solicitante.nome : ''" />
        <TableColumn  :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.favorecido ? obj.favorecido.nome : ''" />
        <TableColumn  :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.favorecido && obj.favorecido.cargo ? obj.favorecido.cargo.nome : ''" />
        <TableColumn  :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.obra ? obj.obra.referencia + ' - ' + obj.obra.localizacao : ''" />
        <TableColumn  :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.responsavel ? obj.responsavel.nome : ''" />
        <TableColumn  :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.secaoRH ? obj.secaoRH.nome : ''" />
        <TableColumn  :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="formatMoney(obj.valorSolicitado)" />
        <TableColumn  :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.motivoViagem ? obj.motivoViagem.nome : ''" />
        <TableColumn  :IsDatetime="true" v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.dataViagemInicio" />
        <TableColumn  :IsDatetime="true" v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.dataViagemFim" />
        <TableColumn  :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="setFormaCityState(obj.cidadeOrigem)" />
        <TableColumn  :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="setFormaCityState(obj.cidadeDestino)" />
        <TableColumn  :IsCustom="true" class="text-center">
            <b-badge v-if="obj.situacao == null || obj.situacao == 0" variant="warning" pill style="padding: 6px 10px 6px 10px;">AGUARDANDO APROVAÇÃO <br>RESPONSÁVEL OBRA</b-badge>
            <b-badge  variant="warning" pill style="padding: 6px 10px 6px 10px;">{{getSituacao(obj.situacao)}}</b-badge>
            <!-- <b-badge v-else-if="obj.situacao == 2" variant="warning" pill style="padding: 6px 10px 6px 10px;">AGUARDANDO APROVAÇÃO<br> DIRETORIA</b-badge>
            <b-badge v-else-if="obj.situacao == 3" variant="success" pill style="padding: 6px 10px 6px 10px;">APROVADO</b-badge>
            <b-badge v-else-if="obj.situacao == -1" variant="danger" pill style="padding: 6px 10px 6px 10px;">REPROVADO <br>RESPONSÁVEL OBRA</b-badge>
            <b-badge v-else-if="obj.situacao == -2" variant="danger" pill style="padding: 6px 10px 6px 10px;">REPROVADO CONTROLADORIA</b-badge>
            <b-badge v-else-if="obj.situacao == -3" variant="danger" pill style="padding: 6px 10px 6px 10px;">REPROVADO DIRETORIA</b-badge> -->
        </TableColumn>
        <TableColumn  :IsDatetime="true" v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.dataAprovacao" />
        <TableColumn  :IsText="true"   v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.aprovador ? obj.aprovador.nome : ''" />
        <TableColumn  :IsCustom="true" class="text-center">
          <span v-if="obj.motivoReprovacao" v-b-tooltip.hover :title="obj.motivoReprovacao"><i class="fas fa-comment-alt" style="font-size: 15px; color: #ff0000;"></i></span>
          <span>&nbsp;</span>
        </TableColumn>

        <TableColumn  :IsCustom="true" class="text-center">
          <!-- <span class="text-third" v-if="obj.situacao === 3 && == false" v-b-tooltip.hover :title="'Clonar'" @click="onClone(obj)"><i class="fa fa-clone icone-grid"></i></span> -->
        </TableColumn>
        <!-- <TableColumn  :IsText="true" v-on:Edit="onSelect(obj)" :status="obj.status" :value="obj.valorSolicitado" /> -->
      </tr>
      <template slot="ButtonsAprova">
            <button type="button"  class="btn-apro" v-b-tooltip.hover :title="'Reprovar selecionados'" @click="Disaproved"><i class="fas fa-times-circle"></i> Reprovar</button>
            <button type="button"  class="btn-repro" v-b-tooltip.hover :title="'Aprovar selecionados'" @click="AprovedTerm"><i class="fas fa-check-circle"></i> Aprovar</button>&nbsp;
      </template>
    </Tables>
          </b-tab>
          <b-tab :title="'Autorizações'">
            <template slot="title">
              <i class="fas fa-file-contract text-third"></i><span class="d-md-down-none pl-1 text-third"> Desconto em folha</span>
            </template>
          <Tables ref="tableGridDesc"
            :columns="[
              'Lote',
              'Data Solicitação',
              'Solicitante',
              'Funcionário',
              'Função',
              'Obra',
              'Responsável',
              'Regional',
              'Viagem Motivo',
              'Viagem Início',
              'Viagem Fim',
              'Cidade Origem',
              'Cidade Destino',
              'Situação',
              'Valor',
              'Ações'
            ]"
            :messageTipFooter="$lang.Common.ClickToSelect"
            :showPrint="false"
            :showExportExcel="true"
            :showDownload="false"
            v-on:SaveFile="onDownload"
            v-on:Print="onPrint"
            v-on:Load="onSearch"
            :showCheckInput="true"
            :newHeaderStatus="true"
            v-on:check="checked"
            v-on:ExportExcel="onExportExcel">
      <tr v-for="(obj, index) in dataDiscount" v-bind:key="index">
        <TableColumn :IsCustom="true" :status="obj.status">
          <b-form-checkbox :id="`cbxQuadro-${index}`"
                           v-model="obj.checked"
                           :name="`cbxQuadro-${index}`"
                           :value="obj.id"
                           size="sm" />
        </TableColumn>
        <TableColumn
                     v-on:Edit="onEdit(obj)"
                     :IsText="true"
                     :status="obj.status"
                     :value="obj.lote != null ? obj.lote : ' N/D'" />
        <TableColumn :IsDatetime="true"
                     v-on:Edit="onEdit(obj)"
                     :status="obj.status"
                     :value="obj.dataCriacao" />
        <TableColumn :IsText="true"
                     v-on:Edit="onEdit(obj)"
                     :status="obj.status"
                     :value="obj.solicitante === null ? 'N/D' : obj.solicitante.nome" />
        <TableColumn :IsText="true"
                     v-on:Edit="onEdit(obj)"
                     :status="obj.status"
                     :value="obj.favorecido ? obj.favorecido.nome : ''" />
        <TableColumn :IsText="true"
                     v-on:Edit="onEdit(obj)"
                     :status="obj.status"
                     :value="obj.favorecido && obj.favorecido.cargo ? obj.favorecido.cargo.nome : ''" />
        <TableColumn :IsText="true"
                     v-on:Edit="onEdit(obj)"
                     :status="obj.status"
                     :value="obj.obra ? obj.obra.referencia + ' - ' + obj.obra.localizacao : ''" />
        <TableColumn :IsText="true"
                     v-on:Edit="onEdit(obj)"
                     :status="obj.status"
                     :value="obj.responsavel ? obj.responsavel.nome : ''" />
        <TableColumn :IsText="true"
                     v-on:Edit="onEdit(obj)"
                     :status="obj.status"
                     :value="obj.secaoRH.nome" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.motivoViagem ? obj.motivoViagem.nome : ''" />
        <TableColumn :IsDateOnly="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.dataViagemInicio" />
        <TableColumn :IsDateOnly="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.dataViagemFim" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="setFormaCityState(obj.origem)" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="setFormaCityState(obj.destino)" />
        <TableColumn :IsCustom="true"
                     v-on:Edit="onEdit(obj)"
                     :status="obj.status">
          <b-badge v-if="obj.situacao == null || obj.situacao == 0" variant="warning" pill style="padding: 6px 10px 6px 10px;">EM ELABORAÇÃO</b-badge>
          <b-badge v-else-if="obj.situacao == 1" variant="warning" pill style="padding: 6px 10px 6px 10px;">AGUARDANDO APROVAÇÃO<br> RESPONSÁVEL OBRA</b-badge>
          <b-badge v-else-if="obj.situacao == 2" variant="warning" pill style="padding: 6px 10px 6px 10px;">AGUARDANDO APROVAÇÃO<br> CONTROLADORIA</b-badge>
          <b-badge v-else-if="obj.situacao == 3" variant="warning" pill style="padding: 6px 10px 6px 10px;">AGUARDANDO APROVAÇÃO<br> DIRETORIA</b-badge>
          <b-badge v-else-if="obj.situacao == 4" variant="success" pill style="padding: 6px 10px 6px 10px;">APROVADO</b-badge>
          <b-badge v-else-if="obj.situacao == 5" variant="success" pill style="padding: 6px 10px 6px 10px;">PAGAMENTO REALIZADO</b-badge>
          <b-badge v-else-if="obj.situacao == -1" variant="danger" pill style="padding: 6px 10px 6px 10px;">REPROVADO <br>RESPONSÁVEL OBRA</b-badge>
          <b-badge v-else-if="obj.situacao == -2" variant="danger" pill style="padding: 6px 10px 6px 10px;">REPROVADO CONTROLADORIA</b-badge>
          <b-badge v-else-if="obj.situacao == -3" variant="danger" pill style="padding: 6px 10px 6px 10px;">REPROVADO DIRETORIA</b-badge>
        </TableColumn>
        <TableColumn :IsCustom="true"
                     v-on:Edit="onEdit(obj)"
                     :status="obj.status">
          <strong v-if="-1 * obj.valorTotal >= 0" style="color: #004987">{{formatMoney(-1 * obj.valorTotal)}}</strong>
          <strong v-else class="text-danger">{{formatMoney( -1 * obj.valorTotal)}}</strong>
        </TableColumn>
        <TableColumn :IsActionsButtons="true" :HasChange="false" :HasDelete="obj.situacao === null || obj.situacao === 0" v-on:Delete="onDeleteBoard(obj)" />
      </tr>
       <template slot="ButtonsAprova">
            <button type="button"  class="btn-apro" v-b-tooltip.hover :title="'Reprovar selecionados'" @click="onDesaDisapprovedModal"><i class="fas fa-times-circle"></i> Reprovar</button>
            <button type="button"  class="btn-repro" v-b-tooltip.hover :title="'Aprovar selecionados'" @click="onSetApprovedDesc"><i class="fas fa-check-circle"></i> Aprovar</button>&nbsp;
      </template>
    </Tables>
          </b-tab>
          <b-tab :title="'Pesquisar'">
              <template slot="title">
                <div><i class="fas fa-money-check-alt text-third"></i><span class="d-md-down-none pl-1 text-third"> Reembolso</span></div>
              </template>
          <Tables ref="tableGridReem"
            :columns="[
              'Lote',
              'Data Solicitação',
              'Solicitante',
              'Funcionário',
              'Função',
              'Obra',
              'Responsável',
              'Regional',
              'Viagem Motivo',
              'Viagem Início',
              'Viagem Fim',
              'Cidade Origem',
              'Cidade Destino',
              'Situação',
              'Valor',
              'Ações'
            ]"
            :messageTipFooter="$lang.Common.ClickToSelect"
            :showPrint="false"
            :showExportExcel="true"
            :showDownload="false"
            v-on:Load="getAllReembolso"
            v-on:SaveFile="onDownload"
            v-on:Print="onPrint"
            :showCheckInput="true"
            :newHeaderStatus="true"
            v-on:check="checkedlst"
            v-on:ExportExcel="onExportExcel">
      <tr v-for="(obj, index) in dataReembolso" v-bind:key="index">
        <TableColumn :IsCustom="true" :status="obj.status">
          <b-form-checkbox :id="`lsttwo-${index}`"
                            :name="`lsttwo-${index}`"
                           v-model="obj.checked"
                           :value="obj.id"
                           size="sm" />
        </TableColumn>
           <TableColumn
                     v-on:Edit="onEdit(obj)"
                     :IsText="true"
                     :status="obj.status"
                     :value="obj.lote != null ? obj.lote  : ' N/D'" />
        <TableColumn :IsDatetime="true"
                     v-on:Edit="onEdit(obj)"
                     :status="obj.status"
                     :value="obj.dataCriacao" />
        <TableColumn :IsText="true"
                     v-on:Edit="onEdit(obj)"
                     :status="obj.status"
                     :value="obj.solicitante === null ? 'N/D' : obj.solicitante.nome" />
        <TableColumn :IsText="true"
                     v-on:Edit="onEdit(obj)"
                     :status="obj.status"
                     :value="obj.favorecido ? obj.favorecido.nome : ''" />
        <TableColumn :IsText="true"
                     v-on:Edit="onEdit(obj)"
                     :status="obj.status"
                     :value="obj.favorecido && obj.favorecido.cargo ? obj.favorecido.cargo.nome : ''" />
        <TableColumn :IsText="true"
                     v-on:Edit="onEdit(obj)"
                     :status="obj.status"
                     :value="obj.obra ? obj.obra.referencia + ' - ' + obj.obra.localizacao : ''" />
        <TableColumn :IsText="true"
                     v-on:Edit="onEdit(obj)"
                     :status="obj.status"
                     :value="obj.responsavel ? obj.responsavel.nome : ''" />
        <TableColumn :IsText="true"
                     v-on:Edit="onEdit(obj)"
                     :status="obj.status"
                     :value="obj.secaoRH.nome" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.motivoViagem ? obj.motivoViagem.nome : ''" />
        <TableColumn :IsDateOnly="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.dataViagemInicio" />
        <TableColumn :IsDateOnly="true" v-on:Edit="onEdit(obj)" :status="obj.status" :value="obj.dataViagemFim" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="setFormaCityState(obj.origem)" />
        <TableColumn :IsText="true"   v-on:Edit="onEdit(obj)" :status="obj.status" :value="setFormaCityState(obj.destino)" />
        <TableColumn :IsCustom="true"
                     v-on:Edit="onEdit(obj)"
                     :status="obj.status">
          <b-badge v-if="obj.situacao == null || obj.situacao == 0" variant="warning" pill style="padding: 6px 10px 6px 10px;">EM ELABORAÇÃO</b-badge>
          <b-badge v-else-if="obj.situacao == 1" variant="warning" pill style="padding: 6px 10px 6px 10px;">AGUARDANDO APROVAÇÃO<br> RESPONSÁVEL OBRA</b-badge>
          <b-badge v-else-if="obj.situacao == 2" variant="warning" pill style="padding: 6px 10px 6px 10px;">AGUARDANDO APROVAÇÃO<br> CONTROLADORIA</b-badge>
          <b-badge v-else-if="obj.situacao == 3" variant="warning" pill style="padding: 6px 10px 6px 10px;">AGUARDANDO APROVAÇÃO<br> DIRETORIA</b-badge>
          <b-badge v-else-if="obj.situacao == 4" variant="success" pill style="padding: 6px 10px 6px 10px;">APROVADO</b-badge>
          <b-badge v-else-if="obj.situacao == 5" variant="success" pill style="padding: 6px 10px 6px 10px;">PAGAMENTO REALIZADO</b-badge>
          <b-badge v-else-if="obj.situacao == -1" variant="danger" pill style="padding: 6px 10px 6px 10px;">REPROVADO <br>RESPONSÁVEL OBRA</b-badge>
          <b-badge v-else-if="obj.situacao == -2" variant="danger" pill style="padding: 6px 10px 6px 10px;">REPROVADO CONTROLADORIA</b-badge>
          <b-badge v-else-if="obj.situacao == -3" variant="danger" pill style="padding: 6px 10px 6px 10px;">REPROVADO DIRETORIA</b-badge>
        </TableColumn>
        <TableColumn :IsCustom="true"
                     v-on:Edit="onEdit(obj)"
                     :status="obj.status">
          <strong v-if="-1 * obj.valorTotal>= 0" style="color: #004987">{{formatMoney(-1 * obj.valorTotal)}}</strong>
          <strong v-else class="text-danger">{{formatMoney(-1 * obj.valorTotal)}}</strong>
        </TableColumn>
        <TableColumn :IsActionsButtons="true" :HasChange="false" :HasDelete="obj.situacao === null || obj.situacao === 0" v-on:Delete="onDeleteBoard(obj)" />
      </tr>
        <template slot="ButtonsAprova">
            <button type="button" class="btn-apro" v-b-tooltip.hover :title="'Reprovar selecionados'" @click="onOpenDisapprovedModal"><i class="fas fa-times-circle"></i> Reprovar</button>
            <button type="button"  class="btn-repro" v-b-tooltip.hover :title="'Aprovar selecionados'" v-on:click="onSetApproved"><i class="fas fa-check-circle"></i> Aprovar</button>&nbsp;
      </template>
    </Tables>
            </b-tab>
            <b-tab :title="'Despesas de Viagem'">
            <template slot="title">
              <i class="fas fa-bus text-third"></i><span class="d-md-down-none pl-1 text-third">Despesas de Viagem</span>
            </template>
           <div v-if="tabIndex === 3">
             <travelExpenseTab
              :funcionarioId="funcionarioId"
              :Lote="Lote"
              :shouldSearch="shouldSearch"
              @localidade="localidade = !$event ? 0 : $event"
              @despesaViagemValorTotal="despesaViagemValorTotal = !$event ? 0 : $event"
            />
           </div>
            <!-- <travelexpensezpag/> -->
            <!-- <boardtrevelexpenseemployee :dataexpensesResponse ="dataexpensesResponse" @needGetDespesasViagemDiretoria="getDespesasViagemDiretoria"/> -->
          </b-tab>
            <b-tab :title="'Despesas de Diversos'">
            <template slot="title">
              <i class="fas fa-bus text-third"></i><span class="d-md-down-none pl-1 text-third">Despesas de Diversos</span>
            </template>
           <div v-if="tabIndex === 4">
            <tableboard :funcionarioId="funcionarioId" :Lote="Lote" @despesaDiversosValorTotal="despesaDiversosValorTotal = !$event ? 0 : $event" :shouldSearch="shouldSearch">
            </tableboard>
           </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
    <DetailsTravelComission v-if="editOn" :dataDetails="objDes" ref="ExpenseDetails" />
    <DetailsTravelAdvanced  :dataDetails="dataDetailsTerm" v-if="detailsTerm"></DetailsTravelAdvanced>
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseMixin from '../expenses/travelrefund/mixins/ExpenseMixin'
import ExpenseSearchForm from '../employeeboard/search/search-form'
import Tools from '@/components/tools/Tools.js'
import ExpenseRepository from '@/shared/http/repositories/business/expense.js'
import AutocompleteZ from '@/components/forms/AutocompleteZ'
import Datepicker from 'vuejs-datepicker'
import Newformserarch from '../expenses/travelrefund/newformserarch/newformserarch.vue'
import ExpenseDetails from '../expenses/travelrefund/details/details.vue'
import AcceptanceTermRepository from '@/shared/http/repositories/business/acceptanceterm.js'
import AreaDespesa from '@/shared/utils/areaDespesa.js'
import DeatailsTerm from './components/detailsterm/detailsterm.vue'
import Formserachauthorization from '../expenses/travelrefund/formserachauthorization/formserachauthorization.vue'
import { toast, loading } from '@/shared/utils/UIHelper'
import DetailsTravelAdvanced from '../../travelreimbursement/components/DetailsTravelAdvanced/DetailsTravelAdvanced.vue'
import DetailsTravelComission from '../../travelreimbursement/components/DetailsTravelComission/DetailsTravelComission.vue'
import PermisionMixin from '@/store/module/permission/mixin'
import Roles from '@/shared/utils/roles.js'
import travelExpenseTab from './components/travelExpenseTab/travelExpenseTab.vue'
import ExpenseSearch from './components/travelExpenseTab/components/travelexpensezpag/components/ExpenseSearch/ExpenseSearch.vue'
import tableboard from '@/views/private/miscellaneousreimbursement/components/tableboard/tableboard.vue'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
import Search from './components/travelExpenseTab/components/boardtrevelexpenseemployee/components/search/search.vue'
const Tabs = {
  SEARCH: 0,
  AUTHORIZATION: 1
}
export default {
  name: 'Accountability',
  mixins: [ActionsForm, ExpenseMixin, PermisionMixin],
  update () {
    console.info(this.funcionarioId)
  },
  data () {
    return {
      localidade: null,
      shouldSearch: false,
      Lote: '',
      funcionarioId: '',
      form: ExpenseSearchForm,
      data: ExpenseSearchForm,
      formTeste: {
        situacao: null
      },
      dataDiscount: [],
      dataReembolso: [],
      reprova: false,
      totalDesconto: {
        valorTotal: 0,
        lote: []
      },
      flDesconto: true,
      tabIndex: Tabs.SEARCH,
      totalReembolso: {
        valorTotal: 0,
        lote: []
      },
      objDes: [],
      editOn: false,
      roles: Roles,
      dataTerm: [],
      detailsTerm: false,
      dataDetailsTerm: [],
      dataSituacao: [],
      totalTerm: {
        valorTotal: 0,
        lote: []
      },
      dataexpensesResponse: {},
      dataexpenses: [],
      despesaViagemValorTotal: 0,
      despesaDiversosValorTotal: 0
    }
  },
  components: {
    AutocompleteZ,
    Datepicker,
    Newformserarch,
    Formserachauthorization,
    ExpenseDetails,
    DetailsTravelAdvanced,
    DeatailsTerm,
    DetailsTravelComission,
    Search,
    travelExpenseTab,
    ExpenseSearch,
    tableboard
  },
  watch: {
    tabIndex (newvalue) {
      this.valueTabs(newvalue)
    }
  },
  computed: {
    calcularTotalDespesaViagemUsuario: function () {
      let total = 0
      this.dataexpenses.forEach((Element) => {
        total += Element.valor
      })
      return total
    }
  },
  mounted () {
    // this.calcularTotalDescont(this.data)
    // this.onSearch(this.data)
    // this.calculartotalReembolso(this.data)
    // this.getAllReembolso(this.data)
    // this.getAllTermos()
    // this.getEnumSituacao()
    // this.GetTotalDiretoria(this.CompanySelected)
    this.valueTabs(0)
  },
  methods: {
    onloadFirst () {
      // this.getAllTermos()
    },
    GetTotalDiretoria () {
      loading.push()
      AcceptanceTermRepository.GetTotalDiretoria()
        .then(Response => {
          loading.pop()
          this.totalTerm = Response.data
        })
        .catch(Error => {
          loading.pop()
        })
    },
    onLoadSecond () {
      // this.getAllReembolso(this.data)
    },
    onClickSearch () {
      this.$emit('search', this.formTeste)
    },
    search (obj) {
      if (this.tabIndex === 1) {
        this.onSearch(obj)
      } else {
        this.getAllReembolso(obj)
      }
    },
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    backEditRem () {
      document.location.reload()
    },
    onEdit (obj) {
      this.editOn = true
      this.objDes = obj
    },
    checkedTerm (event) {
      for (let i = 0; i < this.$refs.tableGridTerm.total; i++) {
        let check = document.getElementById('accept-' + i)
        if (check == null) break
        check.checked = event.checked
      }
    },
    backAuth () {
      document.location.reload()
    },
    aparecebotoes () {
      this.reprova = true
    },
    getAllTermSearch () {

    },
    onSearch (obj) {
      loading.push()
      let data = {
        InicioSolicitacao: obj == null ? '' : obj.dataInicioSolicitacao == null ? '' : obj.dataInicioSolicitacao.value,
        FimSolicitacao: obj == null ? '' : obj.dataFimSolicitacao == null ? '' : obj.dataFimSolicitacao.value,
        empresaID: this.CompanySelected,
        AreaDespesa: AreaDespesa.REEMBOLSO_DESPESAS,
        ResponsavelID: obj == null ? '' : obj.responsavelID == null ? '' : obj.responsavelID.value,
        ObraID: obj == null ? '' : obj.obraID == null ? '' : obj.obraID.value,
        favorecidorId: obj == null ? '' : obj.favorecidoID == null ? '' : obj.favorecidoID.value,
        SecaoRHID: obj == null ? '' : obj.secaoRHID == null ? '' : obj.secaoRHID.value,
        DespesaLog: obj == null ? '' : obj.despesaLog == null ? '' : obj.despesaLog.value
      }
      ExpenseRepository.GetAllDiscount(data)
        .then(Response => {
          this.dataDiscount = Response.data.data
          this.$refs.tableGridDesc.LoadAllByData(Response)
          loading.pop()
        })
        .catch((Error) => {
          loading.pop()
          toast.error('error!')
        })
    },
    valueTabs (newvalue) {
      let obj = {}
      if (newvalue === 0) {
        this.GetTotalDiretoria()
        this.getAllTermos(obj)
      }
      if (newvalue === 1) {
        this.getAllDiscount(null)
        this.calcularTotalDescont(obj)
      }
      if (newvalue === 2) {
        this.calculartotalReembolso(obj)
        this.getAllReembolso(null)
      }
      this.flDesconto = !this.flDesconto
    },
    calcularDespesasDiversos (value) {
      this.totalReembolso = value
    },
    onOpenDisapprovedModal () {
      loading.push()
      this.selected = []
      for (let i = 0; i < this.$refs.tableGridReem.total; i++) {
        let input = document.getElementById('lsttwo-' + i)
        if (input !== null) {
          if (input.checked) this.selected.push(input.value)
        }
      }
      if (this.selected.length > 0) {
        const data = {
          Ids: this.selected
        }
        ExpenseRepository.DesaActivedByDiretoria(data)
          .then(Response => {
            this.calculartotalReembolso(this.data)
            this.getAllReembolso(this.data)
            loading.pop()
            toast.success('Adiantamento Reprovado com sucesso')
          })
          .catch(Erro => {
            loading.pop()
            toast.warning('Erro!')
          })
      } else {
        toast.info('Você precisa selecionar algum pedido de autorização para reprová-lo', 'REPROVAR AUTORIZAÇÃO')
        loading.pop()
      }
    },
    onNew () {
      this.$refs.ModalAdd.showModal()
    },
    onSetApproved () {
      this.selected = []
      for (let i = 0; i < this.$refs.tableGridReem.total; i++) {
        let input = document.getElementById('lsttwo-' + i)
        if (input !== null) {
          if (input.checked) this.selected.push(input.value)
        }
      }
      if (this.selected && this.selected.length > 0) {
        loading.push()
        const listApproved = {
          Ids: this.selected
        }
        ExpenseRepository.ActivedByDiretoriaReembolso(listApproved)
          .then((response) => {
            this.getAllReembolso(this.data)
            this.calculartotalReembolso(this.data)
            loading.pop()
          })
          .catch((err) => {
            this.onException(err)
          })
      } else {
        toast.info('Você precisa selecionar algum pedido de autorização para aprovar', 'APROVAR AUTORIZAÇÃO')
      }
    },
    onSetApprovedDesc () {
      this.selected = []
      for (let i = 0; i < this.$refs.tableGridDesc.total; i++) {
        let input = document.getElementById('cbxQuadro-' + i)
        if (input !== null) {
          if (input.checked) this.selected.push(input.value)
        }
      }
      if (this.selected && this.selected.length > 0) {
        loading.push()
        const listApproved = {
          Ids: this.selected
        }
        ExpenseRepository.ActivedByDiretoriaDesc(listApproved)
          .then((response) => {
            this.calcularTotalDescont(this.data)
            this.onSearch(this.data)
            loading.pop()
            toast.success('Desconto em Folha Aprovado com sucesso')
          })
          .catch((err) => {
            this.onException(err)
            toast.warning('Erro!')
          })
      } else {
        toast.info('Você precisa selecionar algum pedido de autorização para aprovar', 'APROVAR AUTORIZAÇÃO')
      }
    },
    onDesaDisapprovedModal () {
      loading.push()
      this.selected = []
      for (let i = 0; i < this.$refs.tableGridDesc.total; i++) {
        let input = document.getElementById('cbxQuadro-' + i)
        if (input !== null) {
          if (input.checked) this.selected.push(input.value)
        }
      }
      if (this.selected && this.selected.length > 0) {
        loading.push()
        const listApproved = {
          Ids: this.selected
        }
        ExpenseRepository.DesaActivedByDiretoria(listApproved)
          .then(Response => {
            this.calcularTotalDescont(this.data)
            this.onSearch(this.data)
            toast.success('Desconto em Folha Reprovado com sucesso')
            loading.pop()
          })
          .catch(err => {
            loading.pop()
            this.onException(err)
            toast.warning('Erro!')
          })
        loading.pop()
      } else {
        toast.info('Você precisa selecionar algum pedido de autorização para reprová-lo', 'REPROVAR AUTORIZAÇÃO')
        loading.pop()
      }
    },

    onDownload () {
      if (this.objList) {
        loading.push()
        for (let i = 0; i < this.$refs.tableGridDesc.pagingLimit; i++) {
          let check = document.getElementById('cbxQuadro-' + i)
          if (check == null) continue
          if (check.checked) {
            this.cbxSelected.push(check.value)
          }
        }

        if (this.cbxSelected.length > 0) {
          setTimeout(function () { loading.close() }, 3000)
          // TODO: implement download from back
        } else {
          toast.warning('Você precisa selecionar algum registro para realizar o download')
          setTimeout(function () { loading.close() }, 1000)
        }
      } else {
        toast.warning('Não há despesas para realizar o download')
      }
    },
    onClear () {
      Tools.ClearDataForms(this.form, this.data)
      this.formTeste.situacao = null
    },
    onClearSection () {
      this.form.secaoRH.value = ''
    },
    getAllDiscount (obj) {
      let filtro = {}
      if (obj == null) {
        let obj = localStoreHelper.prestacaoContas.descontoFolha()
        filtro = {
          EmpresaID: this.CompanySelected,
          AreaDespesa: AreaDespesa.REEMBOLSO_DESPESAS,
          InicioSolicitacao: obj == null ? null : obj.dataInicioSolicitacao == null ? null : obj.dataInicioSolicitacao.value,
          FimSolicitacao: obj == null ? null : obj.dataFimSolicitacao == null ? null : obj.dataFimSolicitacao.value,
          ResponsavelID: obj == null ? '' : obj.responsavelID == null ? '' : obj.responsavelID.value,
          ObraID: obj == null ? '' : obj.obraID == null ? '' : obj.obraID.value,
          FavorecidorId: obj == null ? '' : obj.favorecidoID == null ? '' : obj.favorecidoID.value,
          SecaoRHID: obj == null ? '' : obj.secaoRHID == null ? '' : obj.secaoRHID.value,
          DespesaLog: obj == null ? '' : obj.despesaLog == null ? '' : obj.despesaLog.value
        }
      } else {
        filtro.empresaID = this.CompanySelected
        filtro.AreaDespesa = AreaDespesa.REEMBOLSO_DESPESAS
      }
      let pagingLimit = this.$refs.tableGridDesc === undefined ? 10 : this.$refs.tableGridDesc.pagingLimit
      let pagingIndex = this.$refs.tableGridDesc === undefined ? 1 : this.$refs.tableGridDesc.pagingIndex
      ExpenseRepository.GetAllDiscount(filtro, pagingLimit, pagingIndex)
        .then(Response => {
          this.dataDiscount = Response.data.data
          this.$refs.tableGridDesc.LoadAllByData(Response)
        })
        .catch((Error) => {
          loading.pop()
          toast.error('error!')
        })
    },
    checked (event) {
      for (let i = 0; i < this.$refs.tableGridDesc.pagingLimit; i++) {
        let check = document.getElementById('cbxQuadro-' + i)
        if (check == null) break
        check.checked = event.checked
      }
    },
    checkedlst (event) {
      for (let i = 0; i < this.$refs.tableGridReem.total; i++) {
        let check = document.getElementById('lsttwo-' + i)
        if (check == null) break
        check.checked = event.checked
      }
    },
    onExportExcel () {
      this.exportList = []
      if (this.objList) {
        for (let i = 0; i < this.$refs.tableGridDesc.pagingLimit; i++) {
          let check = document.getElementById('cbxQuadro-' + i)
          if (check == null) continue
          if (check.checked) {
            this.exportList.push(this.objList.find((Element) => Element.id === check.value))
          }
        }
        if (this.exportList.length > 0) {
          ExpenseRepository.ExportExcel(this.exportList)
            .then((response) => {
              if (response.data.code > 0) {
                this.onDownloadExcel(response)
              }
            })
            .catch(Error => {
              loading.pop()
            })
        } else {
          toast.warning('Você precisa selecionar algum registro para exportar')
        }
      }
    },
    getAllReembolso (obj) {
      loading.push()
      if (obj == null) {
        obj = localStoreHelper.prestacaoContas.reembolso()
      }
      let data = {
        empresaID: this.CompanySelected,
        AreaDespesa: AreaDespesa.REEMBOLSO_DESPESAS,
        InicioSolicitacao: obj == null ? null : obj.dataInicioSolicitacao == null ? null : obj.dataInicioSolicitacao.value,
        FimSolicitacao: obj == null ? null : obj.dataFimSolicitacao == null ? null : obj.dataFimSolicitacao.value,
        responsavelID: obj == null ? '' : obj.responsavelID == null ? '' : obj.responsavelID.value,
        ObraID: obj == null ? '' : obj.obraID == null ? '' : obj.obraID.value,
        favorecidorId: obj == null ? '' : obj.favorecidoID == null ? '' : obj.favorecidoID.value,
        SecaoRHID: obj == null ? '' : obj.secaoRHID == null ? '' : obj.secaoRHID.value,
        despesaLog: obj == null ? '' : obj.despesaLog == null ? '' : obj.despesaLog.value
      }
      let pagingLimit = this.$refs.tableGridReem === undefined ? 10 : this.$refs.tableGridReem.pagingLimit
      let pagingIndex = this.$refs.tableGridReem === undefined ? 1 : this.$refs.tableGridReem.pagingIndex
      ExpenseRepository.GetAllReembolsoDiretoria(this.CompanySelected, data, pagingLimit, pagingIndex)
        .then(Response => {
          this.dataReembolso = Response.data.data
          this.$refs.tableGridReem.LoadAllByData(Response)
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
        })
    },
    onPrint () {
      loading.push()

      const objSelected = this.objList.filter(e => e.checked).map(e => e.id)

      if (objSelected.length > 0) {
        ExpenseRepository.Print(objSelected)
          .then((response) => {
            if (response.data.code > 0) {
              let pdfWindow = window.open('Despesa-Diversos.pdf')
              let pdf = encodeURI(response.data.data)
              pdfWindow.document.write(`
                <embed width="100%" height="100%" src="data:application/pdf;base64,${pdf}"></embed>
              `)
            }
          })
          .catch(this.onException)
      } else {
        toast.warning('Você precisa selecionar algum registro!')
      }

      loading.close()
    },
    searchAuth (obj) {
      loading.push()
      AcceptanceTermRepository.GetAllByDiretoria(this.CompanySelected, obj)
        .then(Response => {
          loading.pop()
          this.dataTerm = Response.data.data
          this.$refs.tableGridTerm.LoadAllByData(Response)
        })
        .catch(Error => {
          loading.pop()
        })
    },
    calcularTotalDescont (obj) {
      obj.empresaID = this.CompanySelected
      obj.AreaDespesa = AreaDespesa.REEMBOLSO_DESPESAS
      ExpenseRepository.CalcularTotalDescont(obj)
        .then(Response => {
          this.totalDesconto = Response.data
        })
        .catch(Error => console.log(Error))
    },
    calculartotalReembolso (obj) {
      obj.empresaID = this.CompanySelected
      obj.AreaDespesa = AreaDespesa.REEMBOLSO_DESPESAS
      ExpenseRepository.calculartotalReembolso(obj)
        .then(Response => {
          this.totalReembolso = Response.data
        })
        .catch(Error => console.log(Error))
    },
    setFormaCityState (obj) {
      let result = null
      if (obj && obj.estado) {
        result = obj.nome + ' ' + obj.estado.sigla
      } else {
        result = obj.nome
      }
      return result
    },
    onSelect (obj) {
      this.dataDetailsTerm = obj
      this.detailsTerm = true
    },
    getAllTermos () {
      loading.push()
      let obj = {}
      if (localStoreHelper.prestacaoContas.adiantamento() != null) {
        obj = localStoreHelper.prestacaoContas.adiantamento()
      }
      AcceptanceTermRepository.GetAllByDiretoriaPaging(this.CompanySelected, this.$refs.tableGridTerm.pagingLimit, this.$refs.tableGridTerm.pagingIndex, obj)
        .then(Response => {
          loading.pop()
          this.dataTerm = Response.data.data
          this.$refs.tableGridTerm.LoadAllByData(Response)
        })
        .catch(Error => {
          loading.pop()
        })
    },
    AprovedTerm () {
      this.selected = []
      for (let i = 0; i < this.$refs.tableGridTerm.total; i++) {
        let input = document.getElementById('accept-' + i)
        if (input !== null) {
          if (input.checked) this.selected.push(input.value)
        }
      }
      if (this.selected && this.selected.length > 0) {
        loading.push()
        const listApproved = {
          'listaAprovados': this.selected
        }
        AcceptanceTermRepository.SetApproved(listApproved)
          .then((response) => {
            this.getAllTermos()
            this.GetTotalDiretoria()
            loading.pop()
            toast.success('Adiantamento Aprovado com sucesso')
          })
          .catch((err) => {
            this.onException(err)
            toast.warning('Erro')
          })
      } else {
        toast.info('Você precisa selecionar algum pedido de autorização para aprovar', 'APROVAR AUTORIZAÇÃO')
      }
    },
    Disaproved () {
      this.selected = []
      for (let i = 0; i < this.$refs.tableGridTerm.total; i++) {
        let input = document.getElementById('accept-' + i)
        if (input !== null) {
          if (input.checked) {
            this.selected.push({
              id: input.value,
              motivo: ''
            })
          }
        }
      }
      if (this.selected && this.selected.length > 0) {
        loading.push()
        AcceptanceTermRepository.SetDisapproved(this.selected)
          .then((response) => {
            this.getAllTermos()
            this.GetTotalDiretoria()
            loading.pop()
          })
          .catch((err) => {
            this.onException(err)
          })
      } else {
        toast.info('Você precisa selecionar algum pedido de autorização para aprovar', 'APROVAR AUTORIZAÇÃO')
      }
    },
    backAuthEdit () {
      document.location.reload()
    },
    getEnumSituacao () {
      loading.push()
      ExpenseRepository.GetEnumSituacao()
        .then(Response => {
          loading.pop()
          this.dataSituacao = Response.data
        })
        .catch(Error => loading.pop())
    },
    getSituacao (situacao) {
      let situa = this.dataSituacao.find((Element) => Element.value === situacao)
      if (situa !== undefined) {
        return situa.text
      }
    }
  }
}
</script>

<style>
.salestotal{
  min-height: 125px;
  width: 100%;
  border-radius: 8px;
  background: white;
  padding-bottom: 10px;

}
.title-card-sales{
  font-size: 24px;
  background: #008144;
  padding: 20px;
  border-radius: 8px 8px 0px 0px;
  color: white;
  font-weight: bold;
}
.sales-value{
  height: 100%;
  width: 100%;
  display: flex;
  margin-top: 10px;
  justify-content: center;
  font-size: 28px;
  font-weight: bold;
}
.sales-value-body{
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
}

.serachForm{
  width: 250px;
  height: 30px;
  background: #008144;
  border-radius: 25px;
  color: white;
  border: none;
}

.btn-apro{
  height: 2rem;
  width: 7rem;
  color: white;
  border: none;
  background: red;
  border-radius: 10px;
}
.btn-apro:hover{
  background: rgb(155, 0, 0);
}
.btn-repro{
  height: 2rem;
  width: 7rem;
  color: white;
  border-radius: 10px;
  border: none;
  background: green;
}
.btn-repro:hover{
  background: rgb(0, 102, 0);
}
.serachForm:hover{
  background: #004d29;
}
.serachFormClean{
  width: 250px;
  height: 30px;
  border: none;
  background: #C3C3C3;
  color: black;
  border-radius: 25px;
}
.serachFormClean:hover{
  background: #9c9c9c;
}

</style>



// WEBPACK FOOTER //
// src/views/private/finance/accountability/accountability.vue